import { PropsWithChildren } from 'react'
import { AlertDestructive } from '../alert'
import { Button } from '../button'
import { CardDescription } from '../card'
import { UseMutationResult, UseQueryResult } from '@tanstack/react-query'
import { RotateCw } from 'lucide-react'

interface QueryHanlderProps extends PropsWithChildren {
  queryResult?: UseQueryResult
  mutationResult?: UseMutationResult
  fallback?: React.ReactNode
  disableFallback?: boolean
}

const QueryHandler = ({ queryResult, mutationResult, fallback, children }: QueryHanlderProps) => {
  const data: any = queryResult?.data || mutationResult?.data
  const error = queryResult?.error || mutationResult?.error
  const isError = queryResult?.isError || mutationResult?.isError
  const errorMessage = isError ? error?.message || 'Что-то пошло не так.' : ''
  const errorName = isError ? error?.name || 'Ошибка' : ''
  const isLoading = !!(queryResult?.isLoading || mutationResult?.isPending)
  const isDataEmpty = (!data || data?.length < 1) && !isError
  const refetch = () => queryResult?.refetch()

  const renderLoading = () => {
    if (!isLoading) return null
    return fallback || <Button variant="ghost" size="lg" className="w-full" loading />
  }

  const renderEmptyData = () => {
    if (!isDataEmpty || isLoading) return null
    return <CardDescription className="text-center mt-4">Ничего не найдено!</CardDescription>
  }

  const renderChildren = () => {
    if (isDataEmpty || isLoading) return null
    return children
  }

  const renderError = () => {
    if (!isError) return null
    return (
      <AlertDestructive title={errorName} show={isError} description={errorMessage}>
        <Button variant="ghost" rightIcon={<RotateCw className="w-4 h-4" />} onClick={refetch}>
          пробовать снова
        </Button>
      </AlertDestructive>
    )
  }

  return (
    <>
      {renderError()}
      {renderLoading()}
      {renderEmptyData()}
      {renderChildren()}
    </>
  )
}

export default QueryHandler
